import React from "react";
import { connect } from "react-redux";
import { Animated } from "react-animated-css";
import { GoogleApiWrapper } from "google-maps-react";
import { __MapsApi } from "./../../Core/environment";
import BannerComponent from "./Componentes/Banner/Banner.component";
import UbicacionComponent from "./Componentes/Ubicacion/Ubicacion.component";
import ClasificacionComponent from "./Componentes/Clasificacion/Clasificacion.component";
import procedimientos from "../../Core/procedimientos";
import * as ClasificacionActions from "../../Core/Actions/Clasificacion.action";
import * as SucursalActions from "./../../Core/Actions/Sucursal.action";
import "./Home.page.scss";

class HomePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      clasificacionesAgrupadas: [],
    };
  }

  componentDidMount() {
    this.setState({
      clasificacionesAgrupadas: [],
    });

    this.BuscarClasificaciones();
    this.BuscarSucursales();
  }

  BuscarClasificaciones = async () => {
    const { Clasificaciones } = this.props.clasificacionReducer;

    if (Clasificaciones.length <= 0) {
      const { obtenerClasificaciones } = this.props;
      await obtenerClasificaciones();
    }

    this.AgruparClasificaciones();
  };

  BuscarSucursales = async () => {
    const { Sucursales } = this.props.sucursalReducer;

    if (Sucursales.length <= 0) {
      const { obtenerSucursales } = this.props;
      await obtenerSucursales();
    }
  };

  AgruparClasificaciones = async () => {
    const { Agrupar } = procedimientos.prototype;
    const { Clasificaciones } = this.props.clasificacionReducer;
    const clasificacionesAgrupadas = Agrupar(Clasificaciones, 3);

    this.setState({
      clasificacionesAgrupadas: clasificacionesAgrupadas,
    });
  };

  render() {
    return (
      <>
        <section id="Banner">
          <BannerComponent />
        </section>
        <section id="Catalogo">
          <h2 className="Catalogo__Titulo">
            <span></span>
            <span>Catalogo</span>
            <span></span>
          </h2>
          {this.state.clasificacionesAgrupadas.map(
            (clasificacionFila, index) => {
              return (
                <div className="row mt-0 mt-lg-4" key={index}>
                  {clasificacionFila.map((clasificacion) => {
                    return (
                      <div
                        className="col-12 mt-2 mt-lg-0 col-md-4"
                        key={clasificacion.id}
                      >
                        <Animated
                          animationIn="bounceInUp"
                          animationOut="fadeOut"
                          animationInDelay={200}
                          isVisible={true}
                        >
                          <ClasificacionComponent
                            clasificacion={clasificacion}
                          />
                        </Animated>
                      </div>
                    );
                  })}
                </div>
              );
            }
          )}
        </section>
        <section id="Ubicacion">
          <h2 className="Ubicacion__Titulo">
            <span></span>
            <span>Sucursales</span>
            <span></span>
          </h2>
          <UbicacionComponent
            google={this.props.google}
            Ubicaciones={this.props.sucursalReducer.Sucursales}
          />
        </section>
      </>
    );
  }
}

const mapStateToProps = ({ clasificacionReducer, sucursalReducer }) => {
  return { clasificacionReducer, sucursalReducer };
};

const mapDispatchToProps = {
  ...ClasificacionActions,
  ...SucursalActions,
};

const conector = connect(mapStateToProps, mapDispatchToProps)(HomePage);

export default GoogleApiWrapper({
  apiKey: __MapsApi,
})(conector);
